/**
 * YACHT® Theme Master JavaScript
 * Handles Navigation, Accordions, Gallery Switchers, Modals and Helpers
 */

document.addEventListener('DOMContentLoaded', () => {
  initPageTitleResolver();
  initMobileNav();
  initAccordions();
  initProductGallery();
  initQuantitySteppers();
  initStickyHeader();
});

// Dynamic Page Title Resolver
function initPageTitleResolver() {
  const path = window.location.pathname.toLowerCase();
  const titles = {
    'corporate-gifting': 'Corporate Gifting – YACHT®',
    'materials': 'The Five Fabrics of YACHT®',
    'our-story': 'Our Story – YACHT®',
    'about': 'Our Story – YACHT®',
    'craftsmanship': 'Craftsmanship – YACHT®',
    'crew': 'The Crew – YACHT®',
    'the-crew': 'The Crew – YACHT®',
    'faq': 'FAQs & Customer Care – YACHT®',
    'faqs': 'FAQs & Customer Care – YACHT®',
    'contact': 'Contact Concierge – YACHT®',
    'sustainability': 'Sustainability & Eco Credentials – YACHT®',
    'wishlist': 'Your Wishlist – YACHT®'
  };

  for (const key in titles) {
    if (path.includes(key)) {
      document.title = titles[key];
      break;
    }
  }
}

// Mobile Navigation Drawer
function initMobileNav() {
  const toggleBtn = document.querySelector('[data-mobile-nav-toggle]');
  const closeBtn = document.querySelector('[data-mobile-nav-close]');
  const drawer = document.querySelector('[data-mobile-nav-drawer]');
  const overlay = document.querySelector('[data-drawer-overlay]');

  if (!toggleBtn || !drawer) return;

  function openDrawer() {
    drawer.classList.add('is-open');
    if (overlay) overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  toggleBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
}

// Accordion Component (PDP specs, FAQ, etc.)
function initAccordions() {
  document.querySelectorAll('[data-accordion-trigger]').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('[data-accordion-item]');
      if (!item) return;

      const isCurrentlyActive = item.classList.contains('is-active');
      
      // Optional: close other accordions in the same group
      const group = item.closest('[data-accordion-group]');
      if (group && group.dataset.singleExpand === 'true') {
        group.querySelectorAll('[data-accordion-item]').forEach(el => el.classList.remove('is-active'));
      }

      if (isCurrentlyActive) {
        item.classList.remove('is-active');
      } else {
        item.classList.add('is-active');
      }
    });
  });
}

// PDP Image Gallery Thumbnail Switcher
function initProductGallery() {
  const featuredImg = document.querySelector('[data-gallery-featured-img]');
  const thumbItems = document.querySelectorAll('[data-gallery-thumb]');

  if (!featuredImg || thumbItems.length === 0) return;

  thumbItems.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const newSrc = thumb.getAttribute('data-img-src');
      const newAlt = thumb.getAttribute('data-img-alt') || '';
      
      if (newSrc) {
        featuredImg.setAttribute('src', newSrc);
        featuredImg.setAttribute('alt', newAlt);
      }

      thumbItems.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
    });
  });
}

// Quantity Steppers
function initQuantitySteppers() {
  document.querySelectorAll('[data-quantity-stepper]').forEach(stepper => {
    const input = stepper.querySelector('input[type="number"]');
    const plusBtn = stepper.querySelector('[data-quantity-plus]');
    const minusBtn = stepper.querySelector('[data-quantity-minus]');

    if (!input || !plusBtn || !minusBtn) return;

    plusBtn.addEventListener('click', () => {
      const currentVal = parseInt(input.value, 10) || 1;
      input.value = currentVal + 1;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    minusBtn.addEventListener('click', () => {
      const currentVal = parseInt(input.value, 10) || 1;
      const min = parseInt(input.getAttribute('min'), 10) || 1;
      if (currentVal > min) {
        input.value = currentVal - 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
}

// Sticky Header
function initStickyHeader() {
  const header = document.querySelector('.site-header--sticky');
  if (!header) return;

  let lastScrollTop = 0;
  window.addEventListener('scroll', () => {
    const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
    if (currentScroll > 150) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
    lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;
  }, { passive: true });
}
